<template>
  <div>
    <div class="promoterManage-container div-layout">
      <module-title title="推广用户管理">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-download" @click="handleExportFilter">
            导出
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-back" @click="$router.back()">
            返回
          </el-button>
        </div>
      </module-title>
      <el-form class="searchForm" :inline="true" label-position="right" label-width="100px">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="searchForm.name" name="name" maxlength="10" placeholder="请输入姓名" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="手机号：" prop="phoneNumber">
          <el-input v-model="searchForm.phoneNumber" oninput="value=value.replace(/[^\d]/g,'')" name="phoneNumber" maxlength="11" placeholder="请输入手机号" class="handle-form-input" @change="changeNumber" />
        </el-form-item>
        <el-form-item style="margin-left:15px;">
          <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <el-table v-loading="listLoading" border :data="promoterUserList" highlight-current-row fit element-loading-text="Loading" class="list-table">
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="姓名" prop="name" align="center" />
          <el-table-column label="手机号" prop="phoneNumber" align="center" />
          <el-table-column label="账号类型" prop="spreadTypeName" align="center" />
          <el-table-column label="是否是推广者" width="130" prop="spreaderFlag" align="center">
            <template slot-scope="scope">
              {{ scope.row.spreaderFlag==0 ? '否':'是' }}
            </template>
          </el-table-column>
          <el-table-column label="总佣金（元）" width="130" prop="totalCommissionAmount" align="center" />
          <el-table-column label="操作" prop="name" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" icon="el-icon-edit" @click="unbinding(scope.row)">
                解绑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="page.total"
          :page.sync="page.pageNum"
          :limit.sync="page.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getPromoterList, userPromoterUnbind, getProtectionsInfo, exportSpreaderCustomersExcel } from '@/api/yzdPlatformManage/promoterManage';
export default {
  name: 'PromotionUserManage',
  data() {
    return {
      searchForm: {
        name: '',
        phoneNumber: '',
        spreaderId: ''
      },
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      promoterUserList: [],
      listLoading: false, // 表格刷新loading
      protectionsInfo: {},
      option: {}
    };
  },
  mounted() {
    this.searchForm.spreaderId = this.$route.query.spreaderId;
    this.getTableList();
    this.getProtectionsInfo();
  },
  methods: {
    changeNumber(val) {
      this.searchForm.phoneNumber = val;
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        name: this.searchForm.name,
        phoneNumber: this.searchForm.phoneNumber
      };
      this.getTableList();
    },
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getPromoterList({ ...this.option, spreaderId: this.searchForm.spreaderId, pageNum: this.page.pageNum, pageSize: this.page.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.promoterUserList = [];
          this.page.total = 0;
        } else {
          this.promoterUserList = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        // this.$message({ type: 'warning', message: '暂无数据' });
        this.listLoading = false;
        console.log(err);
      });
    },
    unbinding(row) {
      this.$confirm(`是否解绑该用户，解绑后该用户${this.protectionsInfo.suspensionCommissionIntervalTime || 0}月内将不再参与新的分润;`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        userPromoterUnbind(row.id).then((res) => {
          if (res.code === '0') {
            this.$message({ type: 'success', message: '解绑成功' });
            this.getTableList();
          }
        });
      }).catch(() => {});
    },
    getProtectionsInfo() {
      getProtectionsInfo().then((res) => {
        this.protectionsInfo = res.data;
      }).catch(() => {});
    },
    // 导出
    handleExportFilter() {
      var op = this.searchForm;
      window.location.href = exportSpreaderCustomersExcel(op) ? exportSpreaderCustomersExcel(op) : null;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box{
  padding: 0 30px;
}
.edit-form-input{
  width: 130px;
}
</style>
